import React from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'
import {Container, Row} from '@modifi/ui'

import {DefaultComponentWrapper} from '../common'
import HoverCard from './HoverCard'

const propTypes = {
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      imageUrl: PropTypes.string.isRequired,
      headline: PropTypes.string.isRequired,
      caption: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
    }).isRequired
  ),
}
const defaultProps = {
  cards: [],
}

export type HoverCardsProps = InferPropTypes<typeof propTypes, typeof defaultProps>

export const HoverCards: React.FC<HoverCardsProps> = ({cards}) => (
  <DefaultComponentWrapper>
    <Container>
      <Row justifyContent="center" alignItems="start">
        {cards?.map(card => (
          <HoverCard key={card.headline} {...card} />
        ))}
      </Row>
    </Container>
  </DefaultComponentWrapper>
)

HoverCards.propTypes = propTypes

HoverCards.defaultProps = defaultProps

export default HoverCards
